/**
 * @file: useServiceRecordQrcodeSharing.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { QrcodeSharingCloseOrigin } from '@euler/app/flows/common/QrcodeSharing';
import { useShowQrcodeSharingMoreActions } from '@euler/app/flows/common/functions/useShowQrcodeSharingMoreActions';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { ServiceRecordNavParams } from '@euler/app/flows/record/ServiceRecordFlow';
import { usePersistFn } from '@euler/utils/hooks';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { RefObject } from 'react';
import { View } from 'react-native';

export const useServiceRecordQrcodeSharing = (
  callback?: (origin?: QrcodeSharingCloseOrigin) => void,
) => {
  const { serviceRecord } = useServiceRecordContext();
  const navigation =
    useNavigation<StackNavigationProp<ServiceRecordNavParams>>();

  const showMoreActions = useShowQrcodeSharingMoreActions({
    onViewSubscriptions: () => {
      navigation.navigate('_vehicleSubscriptions', {
        licensePlateNo: serviceRecord.licensePlateNo,
      });
    },
  });

  const onShare = usePersistFn((buttonRef: RefObject<View>) => {
    navigation.navigate('_qrcodeSharing', {
      taskNo: serviceRecord.taskNo,
      orderNo: serviceRecord.orderNo,
      reportNo: serviceRecord.reportNo,
      licensePlateNo: serviceRecord.licensePlateNo,
      storeName: serviceRecord.storeName,
      onClose: origin => {
        callback?.(origin);
        if (origin === 'more') {
          showMoreActions({
            anchor: buttonRef,
          });
        }
      },
    });
  });
  return { onShare };
};
